export default __webpack_public_path__ + "static/media/iconEditDisable.c3f824e6.svg";